import React from "react";
import NotificationBar from "../NotificationBar/NotificationBar";

type Props = {
    on_close_click(): void;
    text: string;
    dimissible?: boolean; 
};

const WarningBar = ({on_close_click, text, dimissible}: Props) => {
    return (
        <NotificationBar variant={'warning'} on_close_click={() => on_close_click()} dismissible={dimissible}>
            {text}
        </NotificationBar>
    )
};

export default WarningBar;
